// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

// const Profile = ({ user, onUpdateUser }) => {
//   const [profileData, setProfileData] = useState({
//     username: '',
//     email: '',
//     role: '',
//     created_at: ''
//   });
//   const [isEditing, setIsEditing] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [message, setMessage] = useState({ type: '', text: '' });
//   const [image, setImage] = useState(null);
//   const [imagePreview, setImagePreview] = useState('');
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchUserProfile();
//   }, [user]);

//   const fetchUserProfile = async () => {
//     try {
//       setLoading(true);
//       // Simulate API call - replace with actual endpoint
//       setTimeout(() => {
//         setProfileData({
//           username: user?.username || 'admin',
//           email: user?.email || 'admin@dairy.com',
//           role: user?.role || 'Administrator',
//           created_at: '2024-01-15T10:30:00Z'
//         });
        
//         // Load image from localStorage if exists
//         const savedImage = localStorage.getItem(`user_${user?.id}_image`);
//         if (savedImage) {
//           setImagePreview(savedImage);
//         }
//         setLoading(false);
//       }, 800);
//     } catch (error) {
//       setMessage({ type: 'error', text: 'Failed to load profile data' });
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setProfileData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Validate file size (5MB max)
//       if (file.size > 5 * 1024 * 1024) {
//         setMessage({ type: 'error', text: 'Image size must be less than 5MB' });
//         return;
//       }
      
//       setImage(file);
      
//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setImagePreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleSaveProfile = async () => {
//     try {
//       setSaving(true);
//       setMessage({ type: '', text: '' });

//       // Simulate API call - replace with actual endpoint
//       setTimeout(() => {
//         // Save image to localStorage
//         if (imagePreview) {
//           localStorage.setItem(`user_${user?.id}_image`, imagePreview);
//         }
        
//         setMessage({ type: 'success', text: 'Profile updated successfully!' });
//         setIsEditing(false);
        
//         // Update parent component with new user data
//         if (onUpdateUser) {
//           onUpdateUser({ ...user, username: profileData.username, email: profileData.email });
//         }
//         setSaving(false);
//       }, 1000);
//     } catch (error) {
//       setMessage({ type: 'error', text: error.message });
//       setSaving(false);
//     }
//   };

//   const handleCancelEdit = () => {
//     setIsEditing(false);
//     fetchUserProfile(); // Reset to original data
//     setMessage({ type: '', text: '' });
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const getInitials = (name) => {
//     return name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : 'U';
//   };

//   if (loading) {
//     return (
//       <div style={styles.loadingContainer}>
//         <div style={styles.spinner}></div>
//         <p style={styles.loadingText}>Loading your profile...</p>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <h1 style={styles.title}>My Profile</h1>
//         <p style={styles.subtitle}>Manage your personal information and profile picture</p>
//       </div>

//       {message.text && (
//         <div style={{
//           ...styles.message,
//           backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
//           color: message.type === 'success' ? '#155724' : '#721c24',
//           borderColor: message.type === 'success' ? '#c3e6cb' : '#f5c6cb'
//         }}>
//           {message.text}
//         </div>
//       )}

//       <div style={styles.profileCard}>
//         <div style={styles.profileHeader}>
//           <h2 style={styles.cardTitle}>Personal Information</h2>
//           {!isEditing && (
//             <button
//               onClick={() => setIsEditing(true)}
//               style={styles.editButton}
//             >
//               <span style={styles.editIcon}>✏️</span>
//               Edit Profile
//             </button>
//           )}
//         </div>

//         <div style={styles.profileContent}>
//           {/* Profile Image Section */}
//           <div style={styles.imageSection}>
//             <div style={styles.imageContainer}>
//               {imagePreview ? (
//                 <img 
//                   src={imagePreview} 
//                   alt="Profile" 
//                   style={styles.profileImage}
//                 />
//               ) : (
//                 <div style={styles.avatarPlaceholder}>
//                   {getInitials(profileData.username)}
//                 </div>
//               )}
//               {isEditing && (
//                 <div style={styles.imageOverlay}>
//                   <label htmlFor="imageUpload" style={styles.uploadLabel}>
//                     <span style={styles.uploadIcon}>📷</span>
//                     Change Photo
//                   </label>
//                   <input
//                     id="imageUpload"
//                     type="file"
//                     accept="image/*"
//                     onChange={handleImageChange}
//                     style={styles.fileInput}
//                   />
//                 </div>
//               )}
//             </div>
            
//             {isEditing && (
//               <div style={styles.imageInfo}>
//                 <p style={styles.imageText}>Recommended: Square JPG or PNG, max 5MB</p>
//               </div>
//             )}
//           </div>

//           {/* Profile Information */}
//           <div style={styles.infoSection}>
//             <div style={styles.formGroup}>
//               <label style={styles.label}>Username</label>
//               {isEditing ? (
//                 <input
//                   type="text"
//                   name="username"
//                   value={profileData.username}
//                   onChange={handleInputChange}
//                   style={styles.input}
//                   placeholder="Enter your username"
//                 />
//               ) : (
//                 <div style={styles.value}>{profileData.username}</div>
//               )}
//             </div>

//             <div style={styles.formGroup}>
//               <label style={styles.label}>Email Address</label>
//               {isEditing ? (
//                 <input
//                   type="email"
//                   name="email"
//                   value={profileData.email}
//                   onChange={handleInputChange}
//                   style={styles.input}
//                   placeholder="Enter your email"
//                 />
//               ) : (
//                 <div style={styles.value}>{profileData.email}</div>
//               )}
//             </div>

//             <div style={styles.formGroup}>
//               <label style={styles.label}>Account Role</label>
//               <div style={styles.roleBadge}>
//                 {profileData.role}
//               </div>
//             </div>

//             <div style={styles.formGroup}>
//               <label style={styles.label}>Member Since</label>
//               <div style={styles.value}>{formatDate(profileData.created_at)}</div>
//             </div>

//             <div style={styles.formGroup}>
//               <label style={styles.label}>User ID</label>
//               <div style={styles.value}>{user?.id || 'N/A'}</div>
//             </div>
//           </div>
//         </div>

//         {isEditing && (
//           <div style={styles.actionButtons}>
//             <button
//               onClick={handleCancelEdit}
//               disabled={saving}
//               style={styles.cancelButton}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleSaveProfile}
//               disabled={saving}
//               style={styles.saveButton}
//             >
//               {saving ? (
//                 <>
//                   <span style={styles.spinnerSmall}></span>
//                   Saving...
//                 </>
//               ) : (
//                 'Save Changes'
//               )}
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Account Statistics */}
//       <div style={styles.statsCard}>
//         <h3 style={styles.statsTitle}>Account Overview</h3>
//         <div style={styles.statsGrid}>
//           <div style={styles.statItem}>
//             <div style={styles.statNumber}>156</div>
//             <div style={styles.statLabel}>Animals Managed</div>
//           </div>
//           <div style={styles.statItem}>
//             <div style={styles.statNumber}>2,847</div>
//             <div style={styles.statLabel}>Milk Records</div>
//           </div>
//           <div style={styles.statItem}>
//             <div style={styles.statNumber}>89%</div>
//             <div style={styles.statLabel}>Activity Rate</div>
//           </div>
//           <div style={styles.statItem}>
//             <div style={styles.statNumber}>2</div>
//             <div style={styles.statLabel}>Years Active</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     maxWidth: '900px',
//     margin: '0 auto',
//     padding: '20px',
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
//   },
//   header: {
//     textAlign: 'center',
//     marginBottom: '30px'
//   },
//   title: {
//     fontSize: '2.5rem',
//     fontWeight: '700',
//     color: '#2c3e50',
//     margin: '0 0 10px 0',
//     background: 'linear-gradient(135deg, #3498db, #2c3e50)',
//     WebkitBackgroundClip: 'text',
//     WebkitTextFillColor: 'transparent'
//   },
//   subtitle: {
//     fontSize: '1.1rem',
//     color: '#7f8c8d',
//     margin: 0
//   },
//   loadingContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '400px'
//   },
//   spinner: {
//     width: '50px',
//     height: '50px',
//     border: '5px solid #f3f3f3',
//     borderTop: '5px solid #3498db',
//     borderRadius: '50%',
//     animation: 'spin 1s linear infinite',
//     marginBottom: '20px'
//   },
//   spinnerSmall: {
//     width: '16px',
//     height: '16px',
//     border: '2px solid transparent',
//     borderTop: '2px solid white',
//     borderRadius: '50%',
//     animation: 'spin 1s linear infinite',
//     marginRight: '8px',
//     display: 'inline-block'
//   },
//   loadingText: {
//     fontSize: '1.1rem',
//     color: '#7f8c8d'
//   },
//   message: {
//     padding: '15px 20px',
//     borderRadius: '10px',
//     marginBottom: '25px',
//     border: '1px solid',
//     fontSize: '14px',
//     fontWeight: '500'
//   },
//   profileCard: {
//     backgroundColor: 'white',
//     borderRadius: '15px',
//     padding: '30px',
//     boxShadow: '0 5px 25px rgba(0,0,0,0.1)',
//     marginBottom: '25px',
//     border: '1px solid #eef2f7'
//   },
//   profileHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '30px',
//     paddingBottom: '20px',
//     borderBottom: '2px solid #f8f9fa'
//   },
//   cardTitle: {
//     fontSize: '1.8rem',
//     fontWeight: '600',
//     color: '#2c3e50',
//     margin: 0
//   },
//   editButton: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px 20px',
//     backgroundColor: '#3498db',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '600',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 2px 10px rgba(52, 152, 219, 0.3)'
//   },
//   editIcon: {
//     fontSize: '16px'
//   },
//   profileContent: {
//     display: 'flex',
//     gap: '40px',
//     alignItems: 'flex-start'
//   },
//   imageSection: {
//     textAlign: 'center',
//     flexShrink: 0
//   },
//   imageContainer: {
//     position: 'relative',
//     width: '150px',
//     height: '150px',
//     borderRadius: '50%',
//     backgroundColor: '#ecf0f1',
//     marginBottom: '15px',
//     overflow: 'hidden',
//     border: '4px solid #bdc3c7',
//     boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
//   },
//   profileImage: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover'
//   },
//   avatarPlaceholder: {
//     width: '100%',
//     height: '100%',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '3.5rem',
//     fontWeight: 'bold',
//     color: '#7f8c8d',
//     background: 'linear-gradient(135deg, #bdc3c7, #ecf0f1)'
//   },
//   imageOverlay: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(0,0,0,0.7)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     opacity: 0,
//     transition: 'opacity 0.3s ease'
//   },
//   uploadLabel: {
//     color: 'white',
//     cursor: 'pointer',
//     textAlign: 'center',
//     fontSize: '14px',
//     fontWeight: '500'
//   },
//   uploadIcon: {
//     display: 'block',
//     fontSize: '24px',
//     marginBottom: '5px'
//   },
//   fileInput: {
//     display: 'none'
//   },
//   imageInfo: {
//     fontSize: '12px',
//     color: '#7f8c8d'
//   },
//   imageText: {
//     margin: 0
//   },
//   infoSection: {
//     flex: 1
//   },
//   formGroup: {
//     marginBottom: '25px'
//   },
//   label: {
//     display: 'block',
//     marginBottom: '8px',
//     fontWeight: '600',
//     color: '#2c3e50',
//     fontSize: '14px'
//   },
//   input: {
//     width: '100%',
//     padding: '12px 15px',
//     border: '2px solid #e0e0e0',
//     borderRadius: '8px',
//     fontSize: '15px',
//     transition: 'all 0.3s ease',
//     boxSizing: 'border-box'
//   },
//   value: {
//     padding: '12px 0',
//     fontSize: '16px',
//     color: '#2c3e50',
//     fontWeight: '500'
//   },
//   roleBadge: {
//     display: 'inline-block',
//     padding: '6px 12px',
//     backgroundColor: '#e3f2fd',
//     color: '#1976d2',
//     borderRadius: '20px',
//     fontSize: '13px',
//     fontWeight: '600'
//   },
//   actionButtons: {
//     display: 'flex',
//     gap: '15px',
//     justifyContent: 'flex-end',
//     marginTop: '30px',
//     paddingTop: '20px',
//     borderTop: '2px solid #f8f9fa'
//   },
//   cancelButton: {
//     padding: '12px 25px',
//     backgroundColor: '#95a5a6',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '15px',
//     fontWeight: '600',
//     transition: 'all 0.3s ease'
//   },
//   saveButton: {
//     display: 'flex',
//     alignItems: 'center',
//     padding: '12px 25px',
//     backgroundColor: '#27ae60',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '15px',
//     fontWeight: '600',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 2px 10px rgba(39, 174, 96, 0.3)'
//   },
//   statsCard: {
//     backgroundColor: 'white',
//     borderRadius: '15px',
//     padding: '25px',
//     boxShadow: '0 5px 25px rgba(0,0,0,0.1)',
//     border: '1px solid #eef2f7'
//   },
//   statsTitle: {
//     fontSize: '1.5rem',
//     fontWeight: '600',
//     color: '#2c3e50',
//     margin: '0 0 20px 0'
//   },
//   statsGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
//     gap: '20px'
//   },
//   statItem: {
//     textAlign: 'center',
//     padding: '20px',
//     backgroundColor: '#f8f9fa',
//     borderRadius: '10px',
//     transition: 'transform 0.3s ease'
//   },
//   statNumber: {
//     fontSize: '2rem',
//     fontWeight: '700',
//     color: '#3498db',
//     marginBottom: '5px'
//   },
//   statLabel: {
//     fontSize: '14px',
//     color: '#7f8c8d',
//     fontWeight: '500'
//   }
// };

// // Add CSS animation
// const styleSheet = document.styleSheets[0];
// styleSheet.insertRule(`
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `, styleSheet.cssRules.length);

// styleSheet.insertRule(`
//   .image-container:hover .image-overlay {
//     opacity: 1;
//   }
// `, styleSheet.cssRules.length);

// export default Profile;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';

const Profile = ({ user, onUpdateUser }) => {
  const [profileData, setProfileData] = useState({
    username: '',
    email: '',
    role: '',
    created_at: ''
  });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.id) {
      fetchUserProfile();
    }
  }, [user]);

  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      
      const response = await fetch(`https://dairy.server.statify.co.ke/api/users/${user.id}`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });

      if (response.ok) {
        const userData = await response.json();
        
        setProfileData({
          username: userData.username || '',
          email: userData.email || '',
          role: userData.role || 'User',
          created_at: userData.created_at || ''
        });
        
        // Load image from localStorage if exists
        const savedImage = localStorage.getItem(`user_${user.id}_image`);
        if (savedImage) {
          setImagePreview(savedImage);
        }
      } else if (response.status === 404) {
        throw new Error('User not found');
      } else {
        throw new Error('Failed to fetch profile data');
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
      swal('Error', error.message || 'Failed to load profile data', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        setMessage({ type: 'error', text: 'Image size must be less than 5MB' });
        return;
      }
      
      setImage(file);
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveProfile = async () => {
    try {
      setSaving(true);
      setMessage({ type: '', text: '' });

      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://dairy.server.statify.co.ke/api/users/${user.id}`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          username: profileData.username,
          email: profileData.email
        }),
      });

      if (response.ok) {
        const updatedUser = await response.json();
        
        // Save image to localStorage
        if (imagePreview) {
          localStorage.setItem(`user_${user.id}_image`, imagePreview);
        }
        
        swal('Success', 'Profile updated successfully!', 'success');
        setIsEditing(false);
        
        // Update parent component with new user data
        if (onUpdateUser) {
          onUpdateUser({ 
            ...user, 
            username: updatedUser.username || profileData.username, 
            email: updatedUser.email || profileData.email
          });
        }
        
        // Refresh profile data with the response from server
        setProfileData(prev => ({
          ...prev,
          username: updatedUser.username || prev.username,
          email: updatedUser.email || prev.email
        }));
      } else {
        const errorData = await response.json();
        throw new Error(errorData.error || errorData.message || 'Failed to update profile');
      }
    } catch (error) {
      console.error('Update error:', error);
      swal('Error', error.message, 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    fetchUserProfile(); // Reset to original data
    setMessage({ type: '', text: '' });
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Not set';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (error) {
      return 'Invalid date';
    }
  };

  const getInitials = () => {
    return profileData.username ? profileData.username.charAt(0).toUpperCase() : 'U';
  };

  if (loading) {
    return (
      <div style={styles.pageContainer}>
        <div style={styles.backgroundAnimation}>
          <div style={styles.orb1}></div>
          <div style={styles.orb2}></div>
          <div style={styles.orb3}></div>
        </div>
        <div style={styles.loadingContainer}>
          <div style={styles.spinner}></div>
          <p style={styles.loadingText}>Loading your profile...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.backgroundAnimation}>
        <div style={styles.orb1}></div>
        <div style={styles.orb2}></div>
        <div style={styles.orb3}></div>
      </div>
      
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.avatarSection}>
            <div style={styles.avatar}>
              {imagePreview ? (
                <img 
                  src={imagePreview} 
                  alt="Profile" 
                  style={styles.avatarImage}
                />
              ) : (
                <div style={styles.avatarPlaceholder}>
                  {getInitials()}
                </div>
              )}
            </div>
            <div style={styles.userInfo}>
              <h1 style={styles.title}>{profileData.username}</h1>
              <p style={styles.subtitle}>{profileData.email}</p>
              <div style={styles.roleBadge}>
                <span style={styles.badgeIcon}>👑</span>
                {profileData.role}
              </div>
            </div>
          </div>
          <div style={styles.securityBadge}>
            <span style={styles.badgeIcon}>🔒</span>
            Verified Profile
          </div>
        </div>

        {message.text && (
          <div style={{
            ...styles.message,
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color: message.type === 'success' ? '#155724' : '#721c24',
            borderColor: message.type === 'success' ? '#c3e6cb' : '#f5c6cb'
          }}>
            {message.text}
          </div>
        )}

        <div style={styles.profileCard}>
          <div style={styles.profileHeader}>
            <h2 style={styles.cardTitle}>
              <span style={styles.titleIcon}>👤</span>
              Profile Information
            </h2>
            {!isEditing && (
              <button
                onClick={() => setIsEditing(true)}
                style={styles.editButton}
              >
                <span style={styles.editIcon}>✏️</span>
                Edit Profile
              </button>
            )}
          </div>

          <div style={styles.profileContent}>
            {/* Profile Image Section */}
            <div style={styles.imageSection}>
              <div style={styles.imageContainer}>
                {imagePreview ? (
                  <img 
                    src={imagePreview} 
                    alt="Profile" 
                    style={styles.profileImage}
                  />
                ) : (
                  <div style={styles.avatarPlaceholderLarge}>
                    {getInitials()}
                  </div>
                )}
                {isEditing && (
                  <div style={styles.imageOverlay}>
                    <label htmlFor="imageUpload" style={styles.uploadLabel}>
                      <span style={styles.uploadIcon}>📷</span>
                      Change Photo
                    </label>
                    <input
                      id="imageUpload"
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      style={styles.fileInput}
                    />
                  </div>
                )}
              </div>
              
              {isEditing && (
                <div style={styles.imageInfo}>
                  <p style={styles.imageText}>Recommended: Square JPG or PNG, max 5MB</p>
                </div>
              )}
            </div>

            {/* Profile Information - Only Username and Email */}
            <div style={styles.infoSection}>
              <div style={styles.formGroup}>
                <label style={styles.label}>
                  <span style={styles.labelIcon}>👤</span>
                  Username
                </label>
                {isEditing ? (
                  <input
                    type="text"
                    name="username"
                    value={profileData.username}
                    onChange={handleInputChange}
                    style={styles.input}
                    placeholder="Enter your username"
                  />
                ) : (
                  <div style={styles.value}>{profileData.username}</div>
                )}
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>
                  <span style={styles.labelIcon}>📧</span>
                  Email Address
                </label>
                {isEditing ? (
                  <input
                    type="email"
                    name="email"
                    value={profileData.email}
                    onChange={handleInputChange}
                    style={styles.input}
                    placeholder="Enter your email"
                  />
                ) : (
                  <div style={styles.value}>{profileData.email}</div>
                )}
              </div>
            </div>
          </div>

          {isEditing && (
            <div style={styles.actionButtons}>
              <button
                onClick={handleCancelEdit}
                disabled={saving}
                style={styles.cancelButton}
              >
                Cancel
              </button>
              <button
                onClick={handleSaveProfile}
                disabled={saving}
                style={styles.saveButton}
              >
                {saving ? (
                  <>
                    <span style={styles.spinnerSmall}></span>
                    Saving...
                  </>
                ) : (
                  'Save Changes'
                )}
              </button>
            </div>
          )}
        </div>

        {/* Account Statistics - Simplified */}
        <div style={styles.statsCard}>
          <h3 style={styles.statsTitle}>
            <span style={styles.titleIcon}>📈</span>
            Account Overview
          </h3>
          <div style={styles.statsGrid}>
            <div style={styles.statItem}>
              <div style={styles.statIcon}>👤</div>
              <div style={styles.statContent}>
                <div style={styles.statNumber}>{profileData.username}</div>
                <div style={styles.statLabel}>Username</div>
              </div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statIcon}>📧</div>
              <div style={styles.statContent}>
                <div style={styles.statNumber}>{profileData.email}</div>
                <div style={styles.statLabel}>Email Address</div>
              </div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statIcon}>👑</div>
              <div style={styles.statContent}>
                <div style={styles.statNumber}>{profileData.role}</div>
                <div style={styles.statLabel}>Role</div>
              </div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statIcon}>📅</div>
              <div style={styles.statContent}>
                <div style={styles.statNumber}>{formatDate(profileData.created_at)}</div>
                <div style={styles.statLabel}>Member Since</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    position: 'relative',
    overflow: 'hidden',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  },
  backgroundAnimation: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1
  },
  orb1: {
    position: 'absolute',
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)',
    top: '10%',
    left: '10%',
    animation: 'float 6s ease-in-out infinite'
  },
  orb2: {
    position: 'absolute',
    width: '150px',
    height: '150px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 70%)',
    top: '60%',
    right: '15%',
    animation: 'float 8s ease-in-out infinite 2s'
  },
  orb3: {
    position: 'absolute',
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0) 70%)',
    bottom: '20%',
    left: '20%',
    animation: 'float 10s ease-in-out infinite 1s'
  },
  container: {
    position: 'relative',
    zIndex: 2,
    maxWidth: '800px',
    margin: '0 auto',
    padding: '40px 20px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '30px',
    flexWrap: 'wrap',
    gap: '20px'
  },
  avatarSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px'
  },
  avatar: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    fontWeight: 'bold',
    color: 'white',
    boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
    overflow: 'hidden'
  },
  avatarImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  avatarPlaceholder: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: 'white'
  },
  userInfo: {
    color: 'white'
  },
  title: {
    fontSize: '2.8rem',
    fontWeight: '700',
    margin: '0 0 8px 0',
    textShadow: '0 2px 10px rgba(0,0,0,0.3)'
  },
  subtitle: {
    fontSize: '1.3rem',
    margin: '0 0 15px 0',
    opacity: 0.9,
    fontWeight: '300'
  },
  roleBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'rgba(255,255,255,0.2)',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '600',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.3)'
  },
  badgeIcon: {
    fontSize: '16px'
  },
  securityBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: 'rgba(255,255,255,0.2)',
    color: 'white',
    padding: '12px 20px',
    borderRadius: '25px',
    fontSize: '16px',
    fontWeight: '600',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.3)'
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
    position: 'relative',
    zIndex: 2
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '5px solid rgba(255,255,255,0.3)',
    borderTop: '5px solid white',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '20px'
  },
  spinnerSmall: {
    width: '16px',
    height: '16px',
    border: '2px solid transparent',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginRight: '8px',
    display: 'inline-block'
  },
  loadingText: {
    fontSize: '1.1rem',
    color: 'white',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
  },
  message: {
    padding: '15px 20px',
    borderRadius: '12px',
    marginBottom: '25px',
    border: '1px solid',
    fontSize: '14px',
    fontWeight: '500',
    backdropFilter: 'blur(10px)'
  },
  profileCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '20px',
    padding: '35px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
    marginBottom: '25px',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.3)'
  },
  profileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    paddingBottom: '20px',
    borderBottom: '2px solid #f8f9fa'
  },
  cardTitle: {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: '#2c3e50',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  titleIcon: {
    fontSize: '24px'
  },
  editButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 24px',
    backgroundColor: '#667eea',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
  },
  editIcon: {
    fontSize: '16px'
  },
  profileContent: {
    display: 'flex',
    gap: '40px',
    alignItems: 'flex-start'
  },
  imageSection: {
    textAlign: 'center',
    flexShrink: 0
  },
  imageContainer: {
    position: 'relative',
    width: '180px',
    height: '180px',
    borderRadius: '50%',
    backgroundColor: '#ecf0f1',
    marginBottom: '15px',
    overflow: 'hidden',
    border: '4px solid #bdc3c7',
    boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
  },
  profileImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  avatarPlaceholderLarge: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '4rem',
    fontWeight: 'bold',
    color: '#7f8c8d',
    background: 'linear-gradient(135deg, #bdc3c7, #ecf0f1)'
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.3s ease'
  },
  uploadLabel: {
    color: 'white',
    cursor: 'pointer',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '500'
  },
  uploadIcon: {
    display: 'block',
    fontSize: '24px',
    marginBottom: '8px'
  },
  fileInput: {
    display: 'none'
  },
  imageInfo: {
    fontSize: '12px',
    color: '#7f8c8d'
  },
  imageText: {
    margin: 0
  },
  infoSection: {
    flex: 1
  },
  formGroup: {
    marginBottom: '25px'
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
    fontWeight: '600',
    color: '#2c3e50',
    fontSize: '14px'
  },
  labelIcon: {
    fontSize: '14px'
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    border: '2px solid #e0e0e0',
    borderRadius: '10px',
    fontSize: '15px',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    fontFamily: 'inherit'
  },
  value: {
    padding: '14px 0',
    fontSize: '16px',
    color: '#2c3e50',
    fontWeight: '500',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center'
  },
  actionButtons: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'flex-end',
    marginTop: '30px',
    paddingTop: '25px',
    borderTop: '2px solid #f8f9fa'
  },
  cancelButton: {
    padding: '14px 28px',
    backgroundColor: '#95a5a6',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
    transition: 'all 0.3s ease'
  },
  saveButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 28px',
    backgroundColor: '#27ae60',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(39, 174, 96, 0.3)'
  },
  statsCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '20px',
    padding: '35px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.3)'
  },
  statsTitle: {
    fontSize: '1.6rem',
    fontWeight: '600',
    color: '#2c3e50',
    margin: '0 0 25px 0',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px'
  },
  statItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    padding: '25px',
    backgroundColor: '#f8f9fa',
    borderRadius: '15px',
    transition: 'transform 0.3s ease'
  },
  statIcon: {
    fontSize: '32px',
    flexShrink: 0
  },
  statContent: {
    flex: 1
  },
  statNumber: {
    fontSize: '1.2rem',
    fontWeight: '700',
    color: '#667eea',
    marginBottom: '5px',
    wordBreak: 'break-word'
  },
  statLabel: {
    fontSize: '14px',
    color: '#7f8c8d',
    fontWeight: '500'
  }
};

// Add CSS animations
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`, styleSheet.cssRules.length);

styleSheet.insertRule(`
  @keyframes float {
    0%, 100% { transform: translateY(0px) scale(1); }
    50% { transform: translateY(-20px) scale(1.05); }
  }
`, styleSheet.cssRules.length);

styleSheet.insertRule(`
  .image-container:hover .image-overlay {
    opacity: 1;
  }
`, styleSheet.cssRules.length);

export default Profile;